export default "__VITE_ASSET__COiOJk$a__"